export default __webpack_public_path__ + "static/media/chief.3854f0bf.svg";